<section class="policy-page">
  <div class="container policy-shell">
    <section class="policy-stage">
      <div class="policy-stage-backdrop"></div>
      <div class="policy-stage-overlay"></div>

      <div class="policy-stage-inner">
        <div class="policy-intro">
          <p class="eyebrow">Privacy Policy</p>
          <h1>Respecting Your Data And Your Trust</h1>
          <p class="policy-lead">
            A tech-driven venture builder focused on strategic growth. We identify high-potential
            opportunities, establish robust foundations, and scale innovative businesses designed
            for long-term endurance.
          </p>
        </div>

        <div class="policy-body">
          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Information we collect</h2>
              <p>
                We collect information you provide through our forms, including your name, email
                address, company details, and any venture or partnership information you share. We
                also collect limited usage data such as device type, browser, and pages visited.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>How we use your information</h2>
              <ul class="policy-points">
                <li>Respond to partnership, venture, or career inquiries.</li>
                <li>Evaluate submissions and collaboration opportunities.</li>
                <li>Share updates about Tricore ventures and initiatives.</li>
              </ul>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Cookies and analytics</h2>
              <p>
                We may use cookies and analytics tools to understand how the site is used and to
                improve performance. You can control cookies through your browser settings.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Legal basis for processing</h2>
              <p>
                We process information to respond to requests, evaluate collaboration opportunities,
                and operate our platforms. Where required, we rely on your consent or legitimate
                interests.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>How we share information</h2>
              <p>
                We do not sell personal data. We may share information with trusted service
                providers that help us operate our website and communications, or when required by
                law.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>International transfers</h2>
              <p>
                Your information may be processed in countries where our teams or service providers
                operate. We take reasonable steps to ensure appropriate safeguards are in place.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Data retention</h2>
              <p>
                We keep personal information only as long as necessary to fulfill the purposes
                described in this policy or to comply with legal obligations.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Data security</h2>
              <p>
                We apply industry-standard security practices and restrict access to authorized team
                members only.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Your choices</h2>
              <p>
                You may request access, correction, or deletion of your information, or opt out of
                marketing communications at any time.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Third-party links</h2>
              <p>
                Our website may include links to external sites. We are not responsible for their
                privacy practices, so please review their policies separately.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Policy updates</h2>
              <p>
                We may update this policy to reflect changes in our practices. Any changes will be
                posted on this page with an updated effective date.
              </p>
            </div>
          </article>

          <article class="policy-card">
            <div class="policy-card-inner">
              <h2>Contact</h2>
              <p>For privacy-related requests, email us at privacy@tricoreholdings.com.</p>
            </div>
          </article>
        </div>

        <p class="policy-meta">Effective Date: April 1, 2026</p>
      </div>
    </section>
  </div>
</section>
